
import React from 'react';

import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActionArea';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';

import ratingService from './service/ratingService';
import { wineSelected } from './state/actions';
import { updatePanel } from './state/thunks';

const useStyles = makeStyles(( /* theme */) => ({
    cardRoot: {
        minWidth: "275px",
        maxWidth: "500px"
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
}));

const WineCard = ({onWineSelected, user, wine, onUpdatePanel}) => {
    const classes = useStyles();

    const handleRateWine = ( /* event */) => {
        onWineSelected(wine);
        onUpdatePanel("WineRating", false);
    }

    const getRatingMessage = () => {
        let rating = ratingService.getUserRating(user.uid, wine);
        if (rating) {
            if (ratingService.ratingComplete(rating)) {
                return (
                    <Typography variant="body2" component="p">
                        Your rating: {ratingService.getScore(rating)}
                    </Typography>
                )
            }
        }

        return (
            <Typography variant="body2" component="p" color="error">
                You have not rated this wine yet!
            </Typography>
        )
    }

    return (
        <Card className={classes.cardRoot}>
            <CardActionArea onClick={handleRateWine}>
                <CardContent>
                    <Typography variant="h5" component="h2">
                        {wine.name}
                    </Typography>
                    <Typography variant="body2" component="p">
                        Vintage: {wine.vintage}
                    </Typography>
                    { getRatingMessage() }
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                        {wine.description}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    )
}

WineCard.propTypes = {
    onWineSelected: PropTypes.func.isRequired, 
    user: PropTypes.object.isRequired, 
    wine: PropTypes.object.isRequired, 
    onUpdatePanel: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    user: state.user,
    currentWine: state.currentWine
});

const mapDispatchToProps = dispatch => ({
    onWineSelected: wine => dispatch(wineSelected(wine)),
    onUpdatePanel: (newPanelName, updateFromPopState) => dispatch(updatePanel(newPanelName, updateFromPopState))
});

export default connect(mapStateToProps, mapDispatchToProps)(WineCard);

